
define('text!templates/modules/calendar/animated-session/tags/list/custom-tag-list-item.html',[],function () { return '<div class="item-section"></div>\n';});

